import { render, staticRenderFns } from "./create-topic.vue?vue&type=template&id=b9923dd0&scoped=true&"
import script from "./create-topic.ts?vue&type=script&lang=ts&"
export * from "./create-topic.ts?vue&type=script&lang=ts&"
import style0 from "./create-topic.scss?vue&type=style&index=0&id=b9923dd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9923dd0",
  null
  
)

export default component.exports